export function SearchHistoryModel(dict) {
    this.partitionKey = dict.PartitionKey || '';
    this.rowKey = dict.RowKey || '';
    this.keyword = dict.Keyword || '';
    this.timestamp = dict.Timestamp || '';
    this.eTag = dict.ETag || '';
}